import { memo, useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery, Typography } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MenuList from '../MenuList';
import MiniDrawerStyled from './MiniDrawerStyled';
import Chip from 'ui-component/extended/Chip';

import LAYOUT_CONST from 'constant';
import useConfig from 'hooks/useConfig';
import { drawerWidth } from 'store/constant';

import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';
import useAuth from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import logoAppleBox from 'assets/applebox/Logo_Applebox.png'
import BtnLClose from 'assets/game/lottery/Btn_Close.png';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = () => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchUp400 = useMediaQuery(theme.breakpoints.up('400'));

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    const { layout, drawerType } = useConfig();

    const {user, logout} = useAuth();
    const navigate = useNavigate();

    const drawerContent = (
        <>
            <MenuList />
        </>
    );

    const drawerSX = {
        paddingLeft: drawerOpen ? '16px' : 0,
        paddingRight: drawerOpen ? '16px' : 0,
        marginTop: drawerOpen ? 0 : '20px',
    };

    const drawer = useMemo(
        () => (
            <>
                <Box sx={drawerSX}>{drawerContent}</Box>
            </>
        ),
        [matchUpMd, drawerOpen, drawerType]
    );

    const onClickLogout = () => {
        logout();
        navigate("/login");
    };

    return (
        
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: drawerWidth }} aria-label="mailbox folders">
            <Drawer
                // variant={'persistent'}
                variant={'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={() => dispatch(openDrawer(!drawerOpen))}
                sx={{
                    '& .MuiDrawer-paper': {
                        mt: 0,
                        zIndex: 1099,
                        width: drawerWidth,
                        color: theme.palette.text.primary,
                        backgroundColor: '#1a1d2e',
                        backgroundImage: 'none',
                        borderRight: '1px solid rgba(255, 255, 255, 0.1)',
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                <Box sx={{mt:2, mx:'auto', width:'86%', display: 'flex', justifyContent:'space-between', alignItems:'center', gap:0.5}}>
                    <img src={logoAppleBox} alt="Farmer" width={46} style={{ }}/>
                    <Typography fontSize={matchUp400 ? '26px':'7vw'} fontWeight={800} color={'#fff'}>APPLEBOX</Typography>
                    <Box component={'img'} width={matchUp400 ? '40px':'36px'} src={BtnLClose} onClick={() => dispatch(openDrawer(!drawerOpen))} />
                </Box>
                {drawer}
            </Drawer>
        </Box>
    );
};

export default memo(Sidebar);
